import React, { useState } from 'react';
import BravoLoader from '../../../Elements/BravoLoader';
import LoadingIcon from '../../../Elements/LoadingIcon';

function LoadersDemoComponent() {
  const [fullscreenShown, setFullscreenShown] = useState(false);
  const showFullscreen = () => {
    setFullscreenShown(true);
    setTimeout(() => setFullscreenShown(false), 2500);
  };
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Inline variant</div>
        <div style={{ width: '100%' }}>
          <BravoLoader
            loading={true}
            variant='inline'
            title='LOADING'
            subtitle='Fetching demo data...'
          />
        </div>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Compact variant / LoadingIcon wrapper</div>
        <BravoLoader
          loading={true}
          variant='compact'
          subtitle=''
        />
        <LoadingIcon loading={true} />
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Fullscreen variant (auto-hides here after 2.5s)</div>
        <button
          type='button'
          className='btn'
          onClick={showFullscreen}
        >
          Show fullscreen loader
        </button>
        {fullscreenShown ? (
          <BravoLoader
            loading={true}
            variant='fullscreen'
            title='LOADING'
            subtitle='Please wait...'
          />
        ) : null}
      </div>
    </div>
  );
}

export const loadersDemo = {
  id: 'loaders',
  title: 'Loaders',
  category: 'Basics',
  importPath: 'Elements/BravoLoader (+ Elements/LoadingIcon wrapper)',
  notes: [
    "Props: loading (default true), variant ('inline' | 'fullscreen' | 'compact'), title, subtitle, className.",
    'LoadingIcon is a thin wrapper rendering the compact variant — kept for legacy call sites.',
    'The loader swaps the favicon to a spinner while active.',
    'Easter egg: on April 1st (or with the unicorns=true opt-in cookie) the inline/fullscreen variants render a full unicorn scene instead of the branded mark; compact always keeps the small mark.',
  ],
  snippet: "<BravoLoader loading={isLoading} variant='inline' title='LOADING' subtitle='Please wait...' />",
  render: LoadersDemoComponent,
};
